import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Comunication, ComunicationReq, DataTablesResponse, DatatableRootObject } from 'src/app/interfaces/interfaces.index';
import { HTTP_OPTIONS, URL_SERVICIOS } from 'src/app/shared';
const URL = `${URL_SERVICIOS}comunication`;

@Injectable({
  providedIn: 'root'
})
export class ComunicationService {

  constructor(private http: HttpClient) { }

  getComunications = (tableObj: DatatableRootObject) => this.http.post<DataTablesResponse<Comunication>>(`${URL}/datatable`, tableObj, HTTP_OPTIONS);

  getComunication = (id: number) => this.http.get<Comunication>(`${URL}/${id}`);

  addComunication = (data: ComunicationReq) => this.http.post<number>(URL, JSON.stringify(data), HTTP_OPTIONS);

  updateComunication = (id: number, data: Comunication) => this.http.put(`${URL}/${id}`, JSON.stringify(data), HTTP_OPTIONS);
  
  changeComunication = (id: number, data: any) => this.http.patch(`${URL}/${id}`, JSON.stringify(data), HTTP_OPTIONS);
  
  deleteComunication = (id: number) => this.http.delete(`${URL}/${id}`);

  testComunication = (id: number, cola: boolean = true) => this.http.get(`${URL}/${id}/test?cola=${cola}`);
}
